import React, { useEffect, useState } from 'react';
import Select from "react-select";
import { Multiselect } from "multiselect-react-dropdown";
import axios from 'axios'
import { Link } from 'react-router-dom';


import {
    Col,
    Card,
    Table,
    Dropdown,
} from "react-bootstrap";

function Taxi() {

    const objectArray = [
        { vehicle: "Cycle", vehicleType: "Two Wheeler" },
        { vehicle: "Bike", vehicleType: "Two Wheeler" },
        { vehicle: "Auto", vehicleType: "Three Wheeler" },
        { vehicle: "E-RICKSHAW", vehicleType: "Three Wheeler" },
        { vehicle: "MICRO", vehicleType: "Four Wheeler" },
        { vehicle: "MINI", vehicleType: "Four Wheeler" },
        { vehicle: "PRIME SEDAN", vehicleType: "Four Wheeler" },
        { vehicle: "PRIME SUV", vehicleType: "Four Wheeler" },
        { vehicle: "LUXURY", vehicleType: "Four Wheeler" },
        { vehicle: "Tata Ace", vehicleType: "Four Wheeler" },
        { vehicle: "TATA 407", vehicleType: "Four Wheeler" },

    ]
    const objectArray1 = [
        { category: "pick/drop", },
        { category: "Food", },
        { category: "Grossary", },
        { category: "Taxi", },


    ]

    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
        </svg>);

    const [selectedOption, setSelectedOption] = useState(null);
    const [isToggled, setIsToggled] = useState(false);
    const onToggle = () => setIsToggled(!isToggled);
    const [Base_KM, setBaseKM] = useState("")
    const [Base_Fare, setBaseFare] = useState("")
    const [Per_KM, setPerKM] = useState("")
    const [selectedValues, setselectedValues] = useState([])
    const [category, setCategory] = useState(" ")
    const [getrole, setrole] = useState([])
    const [pricing, setpricing] = useState([])


    const submitHandler = () => {
        const artical = {

            "Category": category[0].category,
            "Vehicle": [
                {
                    "VehicleType": selectedValues[0].vehicleType,
                    "Name": selectedValues[0].vehicle,
                    "Base_KM": Base_KM,
                    "Base_Fare": Base_Fare,
                    "Per_KM": Per_KM
                }
            ]
        }

        axios.post('http://13.126.117.21:443/go-pricing/add-pricing', artical)
            .then(response =>{})
            .catch(err => console.log(err))
    }


    const selection = (selectedValues) => {
        setselectedValues(selectedValues)
    }

    const selection1 = (selectedValues) => {
        setCategory(selectedValues)
    }

    useEffect(() => {
        axios.get('http://13.126.117.21:443/go-pricing/get-all-pricing')
            .then(response => {
                setpricing(response.data.pricing)
            })

    }, [])

    const deleteHandle = (p) => {
        alert(p)
        axios.delete(`http://13.126.117.21:443/go-pricing/delete-pricing-full/${p}`)
            .then(response => (axios.get('http://13.126.117.21:443/go-pricing/get-all-pricing')
                .then(response => {
                    setpricing(response.data.pricing)

                }))

            )
    }

    return (
        <div className="col-16">



            <div className="card">
                <div className="card-header">
                    <h4 className="card-title">Rider Pricing</h4>
                </div>
                <div className="card-body">
                    <div>
                        <Link to=""><button className="btn btn-light ">Add role</button></Link>
                    </div>
                    {/* <Select
                    defaultValue={selectedOption}
                    onChange={setSelectedOption}
                    options={options}
                    style={{
                        lineHeight: "40px",
                        color: "#7e7e7e",
                        paddingLeft: "15px",
                    }} /> */}



                    <Table responsive id="myTable">
                        <thead>
                            <tr>

                                <th>
                                    <strong>USER ID.</strong>
                                </th>
                                <th>
                                    <strong> Category</strong>
                                </th>
                                <th>
                                    <strong>VehicleType</strong>
                                </th>
                                <th>
                                    <strong>Name</strong>
                                </th>
                                <th>
                                    <strong>Base Fare</strong>
                                </th>
                                <th>
                                    <strong>Distance Fare</strong>
                                </th>
                                <th>
                                    <strong>Base Distance</strong>
                                </th>
                                <th>
                                    <strong>Actions</strong>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* <tr> */}
                            {pricing.map((p, i) => {
                                return p.Category == "Taxi" ? <tr key={p._id}>
                                    <td>{p._id}</td>
                                    <td>{p.Category}</td>
                                    {p.Vehicle.map(g =>
                                        <>
                                            {/* {g.VehicleType.map(i=>)} */}
                                            {/* <td>{g.VehicleType}<button>delete</button></td> */}
                                            <td>{g.Name}</td>
                                            <td>{g.Base_Fare}</td>
                                            <td>{g.Per_KM}</td>
                                            <td>{g.Base_KM}</td>

                                            <td>      <Dropdown>
                                                <Dropdown.Toggle
                                                    variant="warning"
                                                    className="light sharp i-false"
                                                >
                                                    {svg1}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item >Update</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => deleteHandle(p._id)} >


                                                        Delete</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown></td>

                                        </>

                                    )}
                                </tr> : ""
                            }


                            )}


                        </tbody>
                    </Table>





                </div>
            </div>
        </div>
    )
}

export default Taxi
